import React from 'react';
import { makeStyles, createStyles }   from '@material-ui/core/styles';
import Grid           from '@material-ui/core/Grid';
import Typography     from '@material-ui/core/Typography';
import Card           from '@material-ui/core/Card';
import CardActionArea from '@material-ui/core/CardActionArea';
import CardContent    from '@material-ui/core/CardContent';
import InterviewImg from '../img/clinical_f.svg'
import DiagnosisImg from '../img/doctor.svg'
import FollowupImg  from '../img/chart_line.svg'
import MedicineImg  from '../img/medicines.svg'

const useStyles = makeStyles((theme) => createStyles ({
  root: {
    display: 'flex',
    alignItems: 'center',
  },
  details: {
  },
  content: {
    flex: '1 0 auto',
    margin: 0,
    /*height: '5rem',*/
    padding: '8px 0.5rem 8px'
  },
  cover: {
    maxWidth:      65,
    maxHeight:     65,
    display:       'flex',
    alignItems:    'center',
    paddingTop:    1,
    paddingBottom: 1,
  },
  action: {
    width: 60
  },
  controls: {
    display:       'flex',
    alignItems:    'center',
    paddingLeft:   1,
    paddingBottom: 1,
  },
  paper: {
    padding:  2,
    margin:   'auto',
    maxWidth: 500,
  },
  image: {
    width:  64,
    height: 64,
  },
  img: {
    margin:    'auto',
    display:   'block',
    maxWidth:  '60',
    maxHeight: '60',
  },
  multilineText: {
    whiteSpace: 'pre-wrap',
    wordBreak: 'break-word',
  },
}));

/**
 * VariousRecord
 * 診療結果・経過情報・お薬情報を記録するカード。
 * @param {object} props プロパティ
 * @param {('Interview'|'Diagnosis'|'FollowUp'|'Medicine')} props.symptomClass カード種別
 * @param {string} props.symptomContent 表示内容
 * @param {Date} props.registeredDate 登録日
 * @param {string} [props.symptomNote] メモ
 * @param {string} props.MedicalRecordID 症状カードID
 * @param {string} props.DocID 対象ドキュメントID(更新・削除時)
 * @param {function} props.handleUpdateModalOpen 詳細モーダルを開くハンドラー
 */
export default function VariousRecord(props){
  const classes = useStyles()
  const symptomClass   = props.symptomClass    // カードの種類（経過・診察・お薬）
  const symptomContent = props.symptomContent  // 症状の詳細
  const registeredDate = props.registeredDate  // 登録日
  const symptomNote    = props.symptomNote     // メモ
  const DocID          = props.DocID           // （経過・診察結果・お薬）ドキュメントID
  // console.log(`VariousRecord props[${JSON.stringify(props,null,'\t')}]`);

  // カードの種類に応じたパラメータを設定
  let symptomImage    = "";
  let symptomText     = "";
  let handleAction    = function (){};  // 画面遷移処理
  let backgroundColor = "#FFFFFF";

  switch(symptomClass) {
    case "Interview":
      symptomImage    = InterviewImg;
      symptomText     = "問診票"
      handleAction    = ()=>handleInterview(symptomClass);
      backgroundColor = "#d9d2e9"
      console.log("VariousRecord.js view Interview card")
      break
    case "Diagnosis":  // 診察結果
      symptomImage = DiagnosisImg;
      symptomText  = "診断"
      handleAction = ()=>handleDiagnosis(symptomClass, DocID);
      backgroundColor = "#cfe2f3"
      console.log("VariousRecord.js view Diagnosis card")
      break
    case "FollowUp":  // 経過情報
      symptomImage = FollowupImg;
      symptomText  = "経過"
      handleAction = ()=>handleFollowUp(symptomClass, DocID);
      backgroundColor = "#f4cccc"
      console.log("VariousRecord.js view FollowUp card")
      break
    case "Medicine":   // お薬情報
      symptomImage = MedicineImg;
      symptomText  = "お薬"
      handleAction = ()=>handleMedicine(symptomClass, DocID);
      backgroundColor = "#fce5cd"
      console.log("VariousRecord.js view Medicine card")
      break
    default:
      break
  }
  
  /* 処方箋登録 2020/07/11 アイコン非表示化に伴い無効化とする。
  const andleRegistPrescription = (e) =>{
    var btn_input_file = document.getElementById('file_prescription');
    btn_input_file.click();
  }
  */
  
  const handleInterview = (symptomClass) => {
    // console.log("handleInterview("+symptomClass+")")
    // console.log("symptomClass="+symptomClass)
    props.handleUpdateModalOpen(symptomClass, '');
  }

  /**
   * @brief 経過情報画面へ移動
   */
  const handleFollowUp = (symptomClass, DocID) => {
    // console.log("handleFollowUp("+symptomClass+","+DocID+")")
    // console.log("symptomClass="+symptomClass+", DocID="+DocID)
    props.handleUpdateModalOpen(symptomClass, DocID)
  }

  /**
   * @brief 診察結果情報画面へ移動
   */
  const handleDiagnosis = (symptomClass, DocID) => {
    // console.log("handleDiagnosis("+symptomClass+","+DocID+")")
    // console.log("symptomClass="+symptomClass+", DocID="+DocID)
    props.handleUpdateModalOpen(symptomClass, DocID)
  }

  /**
   * @ brief お薬情報画面へ移動
   */
  const handleMedicine = (symptomClass, DocID) => {
    // console.log("handleMedicine("+symptomClass+","+DocID+")")
    // console.log("symptomClass="+symptomClass+", DocID="+DocID)
    props.handleUpdateModalOpen(symptomClass, DocID)
  }

  return (
    <React.Fragment>
      {/*console.log(`symptomClass[${symptomClass}]`)*/}
      {/*{console.log(`thum_url[${thum_url}]`)}*/}
      <Card className={classes.root}>
        <CardActionArea onClick={handleAction}>
          <CardContent className={classes.content} style={{backgroundColor: backgroundColor}}>
            <Grid container alignItems="center">
              <Grid item style={{width: '3rem', marginRight: '.5rem', textAlign: "center"}}>
                {/* <div style={{pointerEvents: 'none', width: '3rem'}}className="btn btn-primary btn-sm">{symptomText}</div> */}
                <img src={symptomImage} alt={symptomText} width="35px" />
                <div>{symptomText}</div>
              </Grid>
              <Grid item style={{width: 'calc(100% - 3.5rem)', padding: "3px", backgroundColor: "#FFFFFF", textAlign: "left"}}>
                <div className="text-left textTitle famikarColor">
                  <Typography variant="subtitle1" className="border-bottom" component="div">
                    {'登録日：' + registeredDate.toString()}
                    {/* {record.CreateTime.getFullYear()}年{record.CreateTime.getMonth()+1}月{record.CreateTime.getDate()}日 */}
                  </Typography>
                  <Typography variant="body1" component="div">
                    <div className={classes.multilineText}>{symptomContent}</div>
                    {/*console.log('symptomContent: ' + symptomContent)*/}
                    <div className={classes.multilineText}>{symptomNote}</div>
                  </Typography>
                </div>
              </Grid>
            </Grid>
          </CardContent>
        </CardActionArea>
      </Card>
    </React.Fragment>
  )
}
